// extracted by mini-css-extract-plugin
export default {"window":"NewServiceTimeWindow_window__WIlZZ","mainContainer":"NewServiceTimeWindow_mainContainer__KK-Ci","btnSave":"NewServiceTimeWindow_btnSave__wn0bM"};